import { useState } from "react";
//---------------------------------------------------------------------
import Modal from "src/components/common/modal";
import { useMyStore } from "src/components/main/mainStore";
import {
    arrayReducer, 
    myAxios, MyFormData
} from "src/components/common/functions";
//---------------------------------------------------------------------
export default function WorkOutForm({
    keyword, 
    closeIt, 
    id, 
    rawData, 
    setRawData, 
    setWorkOuts
}){
    const setShowLoader = useMyStore(state => state.setShowLoader);
    const user = useMyStore(state => state.user);
    const [curSettings, setSettings] = useState(rawData.settings || []);
    //--------------------------------------------------------------------------------------------
    return(
        <Modal 
            closeIt = {closeIt}
            title = {keyword}
            width = {700}
            maxWidth = {"100%"}
            actionKey = "Submit"
            handleFormSubmit = {async e => {
                e.preventDefault();
                const imutableWorkOuts = {};
                const curData = {...rawData};
                const prevSetting = curData.settings;
                Object.entries(curData).forEach(([date, dailyWorkOuts]) => {
                    if(date === "settings") return;
                    imutableWorkOuts[date] = dailyWorkOuts.filter(workOut => 
                        curSettings.map(
                            setting => setting.hashKey
                        ).includes(workOut.hashKey)
                    ).map(workOut => 
                        (prevSetting.find(
                            setting => setting.hashKey === workOut.hashKey
                        ).mode
                        ===
                        curSettings.find(
                            setting => setting.hashKey === workOut.hashKey
                        ).mode)?
                        workOut
                        :
                        {...workOut, sets: []}
                    );
                })
                imutableWorkOuts.settings = curSettings;
                const formData = new MyFormData();
                formData.append("data", JSON.stringify(imutableWorkOuts));
                setShowLoader(true);
                const res = await myAxios("workOuts/workOut.php", formData);
                setShowLoader(false);
                if(!res) return;
                user.workOutId = res.data;
                if(id in imutableWorkOuts){
                    setWorkOuts(imutableWorkOuts[id]);
                }
                setRawData({...imutableWorkOuts, settings: curSettings});
                closeIt();
            }}
        >
            <div>
                {curSettings.map((setting, settingIndex) => 
                <div className = "my-2" key = {settingIndex}>
                    <span className = "blk1">
                        <span className = "font-weight-bold mr-3">Work Out Name:</span>
                        <input required className = "inline form-control mr-3" style = {{flexGrow: 1}} value = {setting.name} onChange = {e => {
                            setSettings([
                                ...curSettings.slice(0, settingIndex), 
                                {...setting, name: e.currentTarget.value},
                                ...curSettings.slice(settingIndex + 1)
                            ]);
                        }}/>
                    </span>
                    <span className = "blk1">
                        <span className = "font-weight-bold mr-3">Mode:</span>
                        <select required className = "inline form-control mr-3" value = {setting.mode || ""} onChange = {e => {
                            const imutableWorkOuts = {...rawData};
                            delete(imutableWorkOuts.settings);
                            if(Object.values(imutableWorkOuts).reduce(arrayReducer, []).map(workOut => workOut.hashKey).includes(setting.hashKey) && !window.confirm("Are you sure to change the mode of this work out?\n\n(This action will remove all the related data.)")) return;
                            setSettings([
                                ...curSettings.slice(0, settingIndex),
                                {...setting, mode: e.currentTarget.value},
                                ...curSettings.slice(settingIndex + 1)
                            ])
                        }}>
                            <option value = "">Select</option>
                            <option>Repetition</option>
                            <option>Duration</option>
                        </select>
                    </span>
                    <span className = "btn btn-danger" onClick = {() => {
                        //check existing;
                        const imutableWorkOuts = {...rawData};
                        delete(imutableWorkOuts.settings);
                        if(Object.values(imutableWorkOuts).reduce(arrayReducer, []).map(workOut => workOut.hashKey).includes(setting.hashKey) && !window.confirm("Are you sure to delete this work out?\n\n(This action will remove all the related data.)")) return;
                        setSettings([
                            ...curSettings.slice(0, settingIndex),
                            ...curSettings.slice(settingIndex + 1)
                        ])
                    }}>Delete</span>
                </div>)}
                <div className = "my-3">
                    <span className = "btn btn-primary" onClick = {() => {setSettings([
                        ...curSettings, {name: "", hashKey: Math.random().toString(36).substring(2)}
                    ])}}>Add Work Out</span>
                </div>
            </div>
        </Modal>
    )
}